import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  align-items: center;
  overflow: hidden;

  @media ${until(Device.MobileLarge)} {
    flex-direction: column;
    gap: 16px;
  }

  @media ${from(Device.MobileLarge)} {
    justify-content: space-between;
  }
`;
const PaginationControls = styled.div `
  display: flex;
  align-items: center;
  gap: ${fluid(0, 30)};

  @media ${until(Device.MobileLarge)} {
    width: 100%;
    justify-content: space-between;
  }

  ul.pagination {
    display: flex;
    align-items: center;
    gap: ${fluid(6, 8)};

    li {
      --borderColour: transparent;
      --bgColour: ${brand.primary.stone};

      [data-disabled='true'] & {
        opacity: 0.75;
        pointer-events: none;
      }

      a {
        --size: ${fluid(33, 42)};
        width: var(--size);
        height: var(--size);

        display: flex;
        justify-content: center;
        align-items: center;
      }

      cursor: pointer;
      user-select: none;
      border-radius: 6px;

      ${fonts.poppins.extraBold};
      font-size: ${fluid(19, 23)};
      line-height: ${fluid(25, 30)};

      &.selected {
        --borderColour: ${brand.tertiary.teal};
        --bgColour: ${brand.primary.white};
      }

      &.break {
        --bgColour: transparent;
      }

      border: 3px solid var(--borderColour);
      background-color: var(--bgColour);

      ${transition('border, background-color, opacity', 0.25, 'ease-out')}
    }

    li.previous,
    li.next {
      display: none;
    }
  }
`;
const PageDisplay = styled.small `
  font-size: 16px;
  line-height: 24px;
  user-select: none;

  ${fonts.poppins.regular};
  span {
    ${fonts.poppins.bold};
  }
`;
const PageButton = styled.button `
  ${ButtonReset}

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:first-child {
    transform: rotate(180deg);
  }

  ${ButtonStyles.Container} {
    --buttonHeight: ${fluid(38, 48)};
    --colourText: ${brand.primary.white};
    --bgColour: ${brand.tertiary.teal};

    --colourTextHover: ${brand.primary.black};
    --borderColour: ${brand.tertiary.teal};
    --borderWidth: 3px;
  }
`;
export const PaginationStyles = {
    Container,
    PageButton,
    PageDisplay,
    PaginationControls,
};
